import _ from 'lodash';

import { LiveClassShiftListItemProps } from '../stories/LiveClassShiftListItem';

export const getLiveClassShiftListItemsFromRawData = (data: any): LiveClassShiftListItemProps[] => {
  const formattedItems: LiveClassShiftListItemProps[] = [];
  _.forEach(data, (rawItem, index) => {
    _.forEach(rawItem.supported_types, (supportedType, __) => {
      _.forEach(supportedType, (___, sType) => {
        formattedItems.push({
          title: supportedType[sType].topic_title,
          type: supportedType[sType].type_id,
          dateTime: index,
          topicId: supportedType[sType].topic_id,
        });
      });
    });
  });
  return formattedItems;
};
